import React, { useState, useEffect } from 'react';

const About = () => {
  // Team data array for easier management
  const teamMembers = [
    {
      id: 1,
      name: "Deepak Keshari",
      role: "Founder and CEO",
      bio: "A technologist by both passion and profession, Deepak believes that technology offers limitless opportunities. He is convinced that, as humans, we are far better equipped to improve the world with it than without it.",
      image: "./images/deepak.png",
      linkedin: "https://www.linkedin.com/in/keshari/"
    },
    {
      id: 2,
      name: "Jason Bruce",
      role: "Fractional Sales & Marketing Director",
      bio: "A commercial leader with extensive experience across sales, marketing, and HR, Jason has built and scaled service-led businesses and brings a strategic, people-focused approach to growth. He leads Tedekstra’s commercial direction, helping organisations replace fragmented systems with one unified platform.",
      image: "./images/Jason.jpg",
      linkedin: "https://www.linkedin.com/in/jason--bruce/"
    },
    {
      id: 3,
      name: "Sandro Maia",
      role: "Group Product Manager",
      bio: "Passionate about digital product management, his main skills lie in delivering value by creating solutions to solve real problems.",
      image: "./images/sandro.png",
      linkedin: "https://www.linkedin.com/in/sandromaia/"
    },
     {
      id: 4,
      name: "Puja Keshari",
      role: "Client Success Manager",
      bio: "Puja is a Client Success Manager at Tedekstra, where she builds strong client relationships, keeps communication smooth, and ensures a great experience. Her thoughtful approach and dedication help create lasting partnerships and deliver real value for every client.",
      image: "./images/puja.jpg",
      linkedin: "https://www.linkedin.com/in/puja-keshri-49870015b/"
    },
    {
      id: 5,
      name: "Vaishali Arora",
      role: "Technical Project Manager",
      bio: "With over 6 years of experience in the IT industry, Vaishali helps companies navigate digital transformation. She specializes in Marketing and Product Life Cycle Development, optimizing digital growth across domains like Legal Tech, Hospitality, and E-commerce.",
      image: "./images/Vaishali.png",
      linkedin: "https://www.linkedin.com/in/vaishali-arora17/"
    },
    {
      id: 6,
      name: "Biswarup Jana",
      role: "Full Stack Developer II",
      bio: "A Full Stack Developer with over 4 years of experience in the MERN stack. Biswarup is an adaptable and responsible professional who excels at logical problem-solving and is committed to delivering high-quality solutions with a practical approach.",
      image: "./images/biswarup.png",
      linkedin: "https://www.linkedin.com/in/biswaruprx/"
    }
  ];

  // State for current slide
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const [slidesToShow, setSlidesToShow] = useState(3);

  // Update slides to show based on window width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 992) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle next slide
  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev >= teamMembers.length - slidesToShow ? 0 : prev + 1
    );
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 10000); // Resume autoplay after 10 sec
  };

  // Handle previous slide
  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev <= 0 ? teamMembers.length - slidesToShow : prev - 1
    );
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 10000); // Resume autoplay after 10 sec
  };

  // Auto-play effect
  useEffect(() => {
    let interval;
    if (autoPlay) {
      interval = setInterval(() => {
        setCurrentSlide((prev) =>
          prev >= teamMembers.length - slidesToShow ? 0 : prev + 1
        );
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [autoPlay, teamMembers.length]);

  return (
    <>
      <section className="p-5 bg-white">
        <div className="container">
          <div className="">
            <div className="row">
              <img
                src="./images/Vector 5.png"
                alt=""
                className="about-border-image"
                aria-hidden="true"
              />

              <div className="col-md-12">
                <h1 className="about-us-head">ABOUT US</h1>
              </div>
              <div className="col-md-8 about-us-section">
                <p className="about-us-subHead">
                  For more than eight years, we’ve collaborated with customers
                  to swiftly expand their teams and also build solutions to
                  address their business obstacles.
                </p>

                <p className="about-us-subHead2">
                  At Tedekstra , we are driven by the belief that technology can
                  transform businesses and elevate their potential. Founded in
                  2017, we have been on a mission to empower organisations with
                  tailored solutions that drive growth, efficiency, and success.
                </p>
              </div>
              <div className="col-md-4">
                <img
                  src="./images/Main Image.png"
                  className="img-fluid"
                  alt="Tedekstra team discussing technology solutions"
                  loading="lazy"
                  width="800"
                  height="600"
                />
              </div>
            </div>
          </div>

          <div className="">
            <div className="row">
              <img
                src="./images/Vector 6.png"
                alt=""
                className="story-border-image2"
                aria-hidden="true"
              />
              <div className="col-md-12">
                <h2 className="about-us-head">Our Story</h2>
              </div>
              <div className="col-md-8 our-story-section">
                <p className="about-us-subHead2-story p-0">
                  Our journey began when a group of passionate technologists saw
                  the white space in the industry to provide flexible and agile
                  solutions. We had a pool of contextual champions and IT
                  experts with cross-industry know-how. With a shared vision, we
                  embarked on a mission to bridge the gap between cutting-edge
                  technology/skills and businesses seeking to harness its power.
                  Over the years, we have evolved into a team of experts who
                  thrive on challenges, creativity, and collaboration.
                </p>

                <div className="row align-items-center mt-5">
                  <div className="col-md-3 text-right border-left">
                    <div className="cyber-image"></div>
                  </div>
                  <div className="col-md-9">
                    <p className="mb-0 cyber-p">
                      Our commitment towards customers is evident from our Cyber
                      Essentials Certification aimed to protect customer data
                      against threats.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <img
                  src="./images/Main Image (1).png"
                  className="img-fluid"
                  alt="Tedekstra team collaborating in modern office"
                  loading="lazy"
                  width="800"
                  height="600"
                />
              </div>
            </div>
          </div>
          <div className="our-story-section mt-5" style={{ marginLeft: "-1.4%" }}>
            <img
              src="./images/Group 37.png"
              alt="Tedekstra global office locations and service areas"
              loading="lazy"
              width="1200"
              height="600"
              className="story-border-image4"
              aria-hidden="true"
            />
            <div className="row">
              <div className="col-md-4 mb-4">
                <div className="card rounded-lg p-4 about-card">
                  <div className="row">
                    <div className="col p-3">
                      <p className="about-card-head-part">Established in</p>
                      <p className="about-card-head mt-2">2017</p>
                      <p className="about-card-head-body">
                        The vision to offer top-quality technical talent
                        anywhere in the world was born.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-md-4 mb-4">
                <div className="card rounded-lg p-4 about-card">
                  <div className="row">
                    <div className="col p-3">
                      <p className="about-card-head mt-2">200+</p>
                      <p className="about-card-head-body">
                        IT Experts with varied technical skills and contextual
                        knowledge.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="card rounded-lg p-4 about-card">
                  <div className="row">
                    <div className="col p-3">
                      <p className="about-card-head mt-2">5+</p>
                      <p className="about-card-head-body">
                        Cities world wide offering global reach and onshore,
                        nearshore, offshore capability.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="card rounded-lg p-4 about-card">
                  <div className="row">
                    <div className="col p-3">
                      <p className="about-card-head mt-2">96%</p>
                      <p className="about-card-head-body">
                        Customer Satisfaction Index with high repeat business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4 mb-4">
                <div className="card rounded-lg p-4 about-card">
                  <div className="row">
                    <div className="col p-3">
                      <p className="about-card-head mt-2">Liverpool, UK</p>
                      <p className="about-card-head-body">
                        Headquartered in Northwest UK and delivery centres in EU
                        and India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              src="./images/Ellipse 5.png"
              alt="Decorative Image"
              className="story-border-image5"
            />
          </div>
        </div>
      </section>
      <section className="our-team py-5 bg-white" data-aos="fade-up">
        <div className="container">
          <p className="company-etho-head-part">our values</p>
          <h1 className="mb-5">
            Our Company's
            <br />
            Ethos
          </h1>
        </div>
        <div className="container">
          <div className="row">
            <div className="col">
              <p>
                <img src="./images/star.png" /> &nbsp;{" "}
                <img src="./images/star2.png" />
              </p>
              <h6>
                Collaboration fuels innovation and drives success. Tedekstra
                fosters a culture of seamless collaboration.
              </h6>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card rounded-lg p-4 etho-card">
                <div className="row">
                  <div className="col p-3">
                    <img src="./images/cap.png" />
                    <p className="etho-card-head mt-4">Our Mission</p>
                    <p className="etho-card-body">
                      Join the ranks of forward-thinking businesses that are
                      embracing the future of software solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card rounded-lg p-4 etho-card">
                <div className="row">
                  <div className="col p-3">
                    <img src="./images/cap2.png" />
                    <p className="etho-card-head mt-4">Our Values</p>
                    <p className="etho-card-body">
                      Customer Centricity
                      <br />
                      Innovation at core
                      <br />
                      Open Communication
                      <br />
                      Collaboration
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 pl-4 pr-4">
              <p className="etho-right-card-head">Flexibility</p>
              <p className="etho-right-card-body">
                We understand no two requirements can be similar and hence we
                tailor our offerings to suit your needs and cashflow.
              </p>
              <p className="etho-right-card-head">Agility</p>
              <p className="etho-right-card-body">
                With technology and industry moving at lightning pace, speed is
                of great essence. We employ toolkits for faster Go-to-market.
              </p>
              <p className="etho-right-card-head">Scalability</p>
              <p className="etho-right-card-body">
                Your satisfaction is our mission. Our dedicated support team is
                here to assist you every step of the way.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="our-team py-5 bg-white" data-aos="fade-up">
        <div className="container">
          <header className="text-center mb-5">
            <p className="our-team-head-part">Our Team</p>
            <h1 className="text-center mb-4">
              The Team Behind Tedekstra
            </h1>
            <p className="lead">Meet the experts driving innovation and excellence in IT solutions</p>
          </header>

          <div className="team-slider-container position-relative">
              <button
                className="slider-arrow slider-arrow-left"
                onClick={prevSlide}
                aria-label="Previous slide"
              >
                <i className="fas fa-chevron-left"></i>
              </button>

              <div className="team-slider-wrapper">
                <div
                  className="team-slider-track"
                  style={{
                    transform: `translateX(-${currentSlide * (100 / slidesToShow)}%)`,
                    transition: 'transform 0.5s ease-in-out'
                  }}
                >
                  {teamMembers.map((member) => (
                    <div key={member.id} className="team-slide" style={{ flex: `0 0 calc(100% / ${slidesToShow})` }}>
                      <div className="card rounded-lg p-4 etho-card h-100">
                        <div className="row">
                          <div className="col-4">
                            <img
                              src={member.image}
                              className="card-img-top"
                              alt={`Team Member ${member.name}`}
                            />
                          </div>
                          <div className="col-8">
                            <p className="etho-card-head">{member.name}</p>
                            <p className="etho-card-head-part">{member.role}</p>
                          </div>
                        </div>
                        <hr style={{ padding: "0", marginBottom: "20px" }} />
                        <p className="etho-card-head-part">{member.bio}</p>
                        <ul className="list-unstyled d-flex mt-2 mb-0">
                          <li className="pr-4 border-right">
                            <a
                              href={member.linkedin}
                              className="text-dark"
                              title="Linked In"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fa-brands fa-linkedin-in"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <button
                className="slider-arrow slider-arrow-right"
                onClick={nextSlide}
                aria-label="Next slide"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
        </div>
      </section>

      <section className="location-image-section" data-aos="fade-up">
        <img src="./images/Group 37.png" alt="Our Locations" />
      </section>
      <hr />
    </>
  );
};

export default About;